import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { ExternalLink, Settings2, FileBarChart, BedDouble, ClipboardList, Tag, CalendarClock, TrendingUp, Users } from "lucide-react";

const OSCAR_BASE = "https://oscar.redforts.com";
const HOTEL_ID = "AHCnLzvj";  // Port Sitges Hotel ID in Oscar
const link = (path) => `${OSCAR_BASE}/${HOTEL_ID}/${path}`;

// Common Oscar deep-links (verified URLs)
const SHORTCUTS = [
  {
    key: "rma",
    label: "RMA - Tiempo",
    description: "Políticas basadas en tiempo",
    icon: Settings2,
    url: link("setup,arm,timepolicies"),  // ✅ Verified
    color: "bg-blue-100 text-blue-700 hover:bg-blue-200",
  },
  {
    key: "rma_occ",
    label: "RMA - Ocupación",
    description: "Políticas basadas en ocupación",
    icon: Settings2,
    url: link("setup,arm,occupancypolicies"),  // ⚠️ Inferred from pattern — verify
    color: "bg-blue-100 text-blue-700 hover:bg-blue-200",
  },
  {
    key: "tariffs",
    label: "Tarifas",
    description: "Precios manuales + min/max",
    icon: Tag,
    url: link("ratemgt"),  // ✅ Verified
    color: "bg-emerald-100 text-emerald-700 hover:bg-emerald-200",
  },
  {
    key: "reports",
    label: "Informes Producción",
    description: "Producción por periodo",
    icon: FileBarChart,
    url: link("report,production"),  // ✅ Verified
    color: "bg-purple-100 text-purple-700 hover:bg-purple-200",
  },
  {
    key: "occupancy",
    label: "Informe Ocupación",
    description: "Ocupación por periodo",
    icon: TrendingUp,
    url: link("report,occupancy"),  // ✅ Verified
    color: "bg-indigo-100 text-indigo-700 hover:bg-indigo-200",
  },
  {
    key: "bookings",
    label: "Reservas",
    description: "Asignadas a alojamiento",
    icon: ClipboardList,
    url: link("reservations?preset=current"),  // ✅ Verified
    color: "bg-amber-100 text-amber-700 hover:bg-amber-200",
  },
  {
    key: "inhouse",
    label: "In House",
    description: "Huéspedes alojados ahora",
    icon: Users,
    url: link("inhouse"),  // ✅ Verified
    color: "bg-teal-100 text-teal-700 hover:bg-teal-200",
  },
  {
    key: "rooms",
    label: "Alojamientos",
    description: "Habitaciones + grupos",
    icon: BedDouble,
    url: link("setup,accommodations"),  // ✅ Verified
    color: "bg-rose-100 text-rose-700 hover:bg-rose-200",
  },
  {
    key: "calendar",
    label: "Calendario",
    description: "Disponibilidad + check-ins",
    icon: CalendarClock,
    url: link("timetable"),  // ✅ Verified
    color: "bg-cyan-100 text-cyan-700 hover:bg-cyan-200",
  },
];

const OscarShortcuts = ({ title = "Atajos a Oscar PMS", compact = false }) => {
  const open = (url) => window.open(url, "_blank", "noopener,noreferrer");

  if (compact) {
    return (
      <Button
        data-testid="oscar-open-btn"
        variant="outline"
        onClick={() => open(link("dashboard"))}
        className="gap-2"
      >
        <ExternalLink className="w-4 h-4" />
        Abrir Oscar PMS
      </Button>
    );
  }

  return (
    <Card data-testid="oscar-shortcuts-card">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <CardTitle className="text-base sm:text-lg flex items-center gap-2">
            <ExternalLink className="w-5 h-5 text-blue-600" />
            {title}
          </CardTitle>
          <Button
            data-testid="oscar-open-main-btn"
            size="sm"
            onClick={() => open(link("dashboard"))}
            className="bg-slate-900 hover:bg-slate-800 text-white"
          >
            <ExternalLink className="w-3.5 h-3.5 mr-1" />
            Abrir Oscar
          </Button>
        </div>
        <p className="text-xs text-slate-500 mt-1">
          Pulsa para abrir Oscar en otra pestaña. Tendrás que hacer login la primera vez.
        </p>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3">
          {SHORTCUTS.map((s) => {
            const Icon = s.icon;
            return (
              <button
                key={s.key}
                data-testid={`oscar-shortcut-${s.key}`}
                onClick={() => open(s.url)}
                className={`text-left p-3 rounded-lg border-2 border-transparent transition-all active:scale-[0.97] ${s.color}`}
              >
                <Icon className="w-5 h-5 mb-1.5" />
                <div className="font-bold text-sm leading-tight">{s.label}</div>
                <div className="text-[10px] opacity-80 mt-0.5 line-clamp-1">{s.description}</div>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default OscarShortcuts;
